<template>
	<a-modal
		title="上分"
		:width="520"
		:visible="visible"
		:confirmLoading="loading"
		:maskClosable="false"
		:forceRender="true"
		@ok="handleOk"
		@cancel="() => { $emit('cancel') }"
	>
		<a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }">
			<a-form-model-item label="用户">
				<span>{{ userLabel }}</span>
			</a-form-model-item>
			<a-form-model-item label="当前余额">
				<span>{{ balanceText }}</span>
			</a-form-model-item>
			<a-form-model-item label="上分金额" prop="rechargeAmount" :rules="amountRules">
				<a-input-number
					v-model="form.rechargeAmount"
					:min="0.01"
					:step="1"
					:precision="2"
					style="width: 100%"
					placeholder="请输入上分金额"
				/>
			</a-form-model-item>
		</a-form-model>
	</a-modal>
</template>

<script>
import { fmtMoney } from '@/utils/money';

const amountRules = [
	{ required: true, type: 'number', message: '必填，不能为空', trigger: 'change' },
];

function emptyForm() {
	return {
		rechargeAmount: undefined,
	};
}

export default {
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		user: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			form: emptyForm(),
			amountRules,
		};
	},
	computed: {
		userLabel() {
			if (!this.user) {
				return '-';
			}
			const name = this.user.nickname || this.user.loginAccount || this.user.id;
			return `${name}（ID:${this.user.id}）`;
		},
		balanceText() {
			if (!this.user) {
				return '-';
			}
			return fmtMoney(this.user.balance);
		},
	},
	watch: {
		visible(val) {
			if (val) {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.clearValidate();
					}
				});
			}
		},
	},
	methods: {
		handleOk() {
			if (!this.$refs.form || !this.user) {
				return;
			}
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return;
				}
				this.$emit('ok', {
					userId: this.user.id,
					rechargeAmount: this.form.rechargeAmount,
				});
			});
		},
	},
};
</script>
